<template>
  <div id="portfolio" class="modal" :style="{ display: (openDialog ? 'block' : 'none') }" ref="portfolioViewer">
    <header>

      <div class="portfolioTitle" >
        <div class="portfolioClose">
          <a href="javascript:void(0);" @click="close"><img class="mark10sen" src="/img/close.png" srcset="/img/close@2x.png 2x" alt="" /></a>
        </div>
        <h1>Portfolio : {{winner && winner.name}}</h1>
      </div>
      <div class="portfolioMenu" >
        <ShareButton ulClassName="portfolioSnsShareBtn" message="この作品ページをシェア" />
      </div>

    </header>
    <div id="portfolioBody" ref="scrollTop">
      <div class="swiper-pagination"></div>
      <div class="photoArea">
        <div class="swiper-portfolio-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide"
                 v-for="portfolioWork in virtualData.slides"
                 :key="portfolioWork.id"
                 :style="slideStyles"
            >
              <div class="photoImage" :style="{ maxWidth: 800, maxHeight: 800 }">
                <img :src="portfolioWork.imageUrl" class="exhPhotoImg" alt=""
                     @load="(event) => { loaded(event, portfolioWork.id) }"
                     :ref="`imageData-${portfolioWork.id}`"
                />
              </div>
              <div class="commentArea">
                <h2 v-if="portfolioWork && portfolioWork.title">{{portfolioWork.title}}</h2>
                <h2 v-else><br/></h2>
                <h3 v-if="portfolioWork && portfolioWork.comment" class="comment">{{portfolioWork.comment}}</h3>
                <h3 v-else><br/></h3>
              </div>
              &nbsp;<br>
              &nbsp;<br>
              &nbsp;<br>
              &nbsp;<br>
              &nbsp;<br>
            </div>
          </div>
        </div>
        <img class="swiper-button-next" src="/img/arwRight.png" srcset="/img/arwRight@2x.png 2x" alt="arrowRight" />
        <img class="swiper-button-prev" src="/img/arwLeft.png" srcset="/img/arwLeft@2x.png 2x" alt="arrowLeft" />
      </div>
    </div>
    <div id="main">
    </div>
    <div class="footer-thumbnail-area">
      <div class="swiper-thumbnail-container thumbnail-swiper">
        <img @click="prevThumbnail" class="swiper-thumbnail-button-prev" :class="{disabledButton: isFirstThumbnails()}" src="/img/arwLeft.png" srcset="/img/arwLeft@2x.png 2x" alt="arrowLeft" />
        <img @click="nextThumbnail" class="swiper-thumbnail-button-next" :class="{disabledButton: isLastThumbnails()}" src="/img/arwRight.png" srcset="/img/arwRight@2x.png 2x" alt="arrowRight"/>
        <div class="swiper-slide">
          <div @click="clickThumbnail" class="thumbnail-image" :class="{ pointer: portfolioWork.id }" v-for="portfolioWork in thumbnailImages" :key="portfolioWork.id" :data-index="portfolioWork.index">
            <img :src="portfolioWork.imageUrlS" alt="" :class="{ active: portfolioWork.index === currentIndex }" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import Swiper from 'swiper/bundle'
import ShareButton from '@/components/modules/ShareButton'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    ShareButton
  },
  props: [
    'isOpen',
    'winner'
  ],
  data () {
    return {
      swiperThumbnail: null,
      swiper: null,
      dialogOpen: false,
      portfolio: {},
      virtualData: {
        slides: []
      },
      width: {},
      height: {},
      page: 0,
      thumbnailImages: [],
      currentIndex: 0
    }
  },
  computed: {
    openDialog: {
      get () {
        return this.isOpen
      },
      set (value) {
        this.$emit('update:isOpen', value)
      }
    },
    slideStyles () {
      return `left: ${this.virtualData.offset}px`
    }
  },
  methods: {
    close () {
      this.openDialog = false

      // swiper削除
      if (this.swiper) {
        this.swiper.destroy()
      }
      
      // 一覧ページへURL書き換え
      const index = this.$route.path.indexOf('/portfolios/')
      if (index >= 0) {
        const urlPath = this.$route.path.substring(0, index)
        this.$router.push(urlPath)
      }
    },
    // スワイプ移動イベント
    slideChange (event) {
      // イベント設定
      this.$ga.event('Portfolio', 'swipe', 'portfolio', event.activeIndex)
      this.currentIndex = event.activeIndex

      if (this.page != Math.floor(this.currentIndex / 9)) {
        this.page = Math.floor(this.currentIndex / 9)
        this.createThumbnail()
      }
      // 指定ページのURLに書き換え
      const idx = this.$route.path.indexOf('/portfolios/')
      const path = `${this.$route.path.substring(0, idx)}/portfolios/${this.portfolio.id}/${this.currentIndex+1}`
      if (this.$route.path != path) {
        this.$router.push(path)
      }
    },
    // 画像読み込み時サイズ確定処理
    loaded (event, id) {
      let defaultWidth = 800
      const img = this.$refs['imageData-' + String(id)]
      if (defaultWidth > document.documentElement.clientWidth) {
        // そもそも画面サイズが想定サイズより小さかった場合、想定サイズ自体を小さくする
        defaultWidth = document.documentElement.clientWidth
      }
      if (img[0].naturalWidth > img[0].naturalHeight) {
        // 横位置画像
        this.$set(this.width, id, `${defaultWidth}px`)
        this.$set(this.height, id, (defaultWidth * img[0].naturalHeight / img[0].naturalWidth) + 'px')
      } else if (img[0].naturalWidth < img[0].naturalHeight) {
        // 縦位置画像
        this.$set(this.width, id, (defaultWidth * img[0].naturalWidth / img[0].naturalHeight) + 'px')
        this.$set(this.height, id, `${defaultWidth}px`)
      } else {
        // 正方形
        this.$set(this.width, id, `${640 / 800 * defaultWidth}px`)
        this.$set(this.height, id, `${640 / 800 * defaultWidth}px`)
      }
    },
    isFirstThumbnails () {
      if(this.page == 0) {
        return true
      }
      return false
    },
    isLastThumbnails () {
      if (!this.portfolio || !this.portfolio.portfolioWorks) return true
      if(this.page * 9 + 9 >= this.portfolio.portfolioWorks.length) {
        return true
      }
      return false
    },
    prevThumbnail () {
      this.page--
      if (this.page < 0) this.page = 0
      this.createThumbnail()
    },
    nextThumbnail () {
      this.page++
      if (this.page > Math.floor(this.portfolio.portfolioWorks.length / 9)) {
        this.page = Math.floor(this.portfolio.portfolioWorks.length / 9)
      }
      this.createThumbnail()
    },
    createThumbnail () {
      let startIdx = this.page * 9
      if (startIdx >= this.portfolio.portfolioWorks.length) {
        startIdx = this.portfolio.portfolioWorks.length - 1
      }
      let endIdx = startIdx + 9
      if (endIdx > this.portfolio.portfolioWorks.length) {
        endIdx = this.portfolio.portfolioWorks.length
      }
      this.thumbnailImages = []
      for (let i = startIdx; i < endIdx; i++) {
        const portfolioWork = this.portfolio.portfolioWorks[i]
        portfolioWork.index = i
        this.thumbnailImages.push(portfolioWork)
      }
      const n = 9 - this.thumbnailImages.length
      for (let i = 0; i < n; i++) {
        this.thumbnailImages.push({
          imageUrlS: '/img2022/black_space.jpg'
        })
      }
    },
    clickThumbnail (e) {
      const index = e.currentTarget.getAttribute('data-index')
      setTimeout(() => {
        this.swiper.slideTo(index, 500, false)
      }, 300)
    }
  },
  watch: {
    isOpen: function (value) {
      if (value) {
        if (!this.winner.portfolios || this.winner.portfolios.length <= 0) {
          return
        }
        // スライドデータ初期化
        this.virtualData = {
          slides: []
        }
        // ポートフォリオ設定
        this.portfolio = this.winner.portfolios[0]

        // サムネイルデータ作成
        this.page = 0
        this.createThumbnail()

        // swiper初期設定
        const self = this
        this.swiper = new Swiper('.swiper-portfolio-container', {
          shortSwipes: true,
          noSwiping: true,
          noSwipingSelector: '.notSwipe,input,textarea',
          observer: true,
          observeParents: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction'
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          thumbs: {
            swiper: this.swiperThumbnail
          },
          virtual: {
            slides: this.portfolio.portfolioWorks,
            renderExternal (data) {
              self.virtualData = data
            }
          },
          on: {
            slideChange: this.slideChange
          }
        })

        // indexが指定されていた場合、該当ページにポートフォリオを移動
        if (this.$route.params.index) {
          this.currentIndex = this.$route.params.index - 1
          if (this.currentIndex < 0) this.currentIndex = 0
          if (this.currentIndex >= this.portfolio.portfolioWorks.length) this.currentIndex = this.portfolio.portfolioWorks.length - 1
          setTimeout(() => {
            this.swiper.slideTo(this.currentIndex, 500, false)
          }, 300)
        }

        // イベント記録
        this.$ga.event('Portfolio', 'open', 'portfolio', this.portfolio.id)
      }
    },
    '$route.path': function (val, oldVal) {
      // '/portfolios/'が含まれないURLに変わった場合は、画面が遷移したと判定しclose処理
      const oldIndex = oldVal.indexOf('/portfolios/')
      const newIndex = val.indexOf('/portfolios/')
      if (oldIndex >= 0 && newIndex < 0) {
        this.close()
      }
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  display: none;
  opacity: 1;
  overflow: hidden;
  overflow-y: auto;
  background-color: white;
  z-index: 9999;
}

#portfolioBody {
  position: relative;  
}

.swiper-button-next {
  position: fixed;
  top: calc(100vh * 0.45);
  right: 24px;
  user-select: none;
}

.swiper-button-prev {
  position: fixed;
  top: calc(100vh * 0.45);
  left: 8px;
  user-select: none;
}

.commentArea {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 120px;
}

.comment {
  white-space: pre-wrap;
  max-width: 700px;
  width: 100%;
  padding: 0px 24px;
  text-align: center;
}

.footer-thumbnail-area {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  height: 120px;
  background-color: black;
  display: flex;
  flex-direction: row;
  justify-content: center;
  z-index: 9999;
  overflow: hidden;
  user-select: none;
}

.thumbnail-swiper {
  height: 120px;
  width: calc(100vw - 128px);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.swiper-thumbnail-button-next {
  position: fixed;
  bottom: 48px;
  right: 16px;
  width: 23px;
  height: 24px;
  z-index:9999;
  cursor: pointer;
}

.swiper-thumbnail-button-prev {
  position: fixed;
  bottom: 48px;
  left: 16px;
  width: 23px;
  height: 24px;
  z-index:9999;
  cursor: pointer;
}

.footer-thumbnail-area .swiper-slide {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}


.thumbnail-image {
  display: block;
  position: relative;
  max-width: 96px;
  width: 100%;
  margin: 2px;
}

.thumbnail-image::before {
  content: "";
  display: block;
  padding-top: 100%;
}

.thumbnail-image img {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumbnail-image .active {
  border: 1px solid #999999;
}

.thumbnail-image.pointer {
  cursor: pointer;
}

.disabledButton {
  opacity:0.35;
  pointer-events: none;
}


@media screen and (max-width:640px) {
  #portfolioBody {
    position: static;
  }

  .swiper-button-next {
    position: absolute;
    top: 147px;
    right: 8px;
    width: 18px;
    height: 18px;
  }

  .swiper-button-prev {
    position: absolute;
    top: 147px;
    left: 8px;
    width: 18px;
    height: 18px;
  }

  .footer-thumbnail-area {
    height: 72px;
  }

  .thumbnail-swiper {
    height: 72px;
    width: calc(100vw - 64px);
  }

  .swiper-thumbnail-button-next {
    bottom: 24px;
    right: 4px;
    width: 23px;
    height: 24px;
  }

  .swiper-thumbnail-button-prev {
    bottom: 24px;
    left: 4px;
    width: 23px;
    height: 24px;
  }
}

/* ページネーション上書き */
.swiper-pagination {
  margin-bottom: 20px;
  font-size: 1.6em;
  position: static;
}
</style>
